import {
  AcceptStateEnum,
  PurchaseOrder,
  PurchaseOrderAdd,
  PurchaseOrderAddItem,
  PurchaseOrderItem,
  PurchaseOrderStateEnum,
  PurchasefFnishStateEnum,
  PurchasefInStateEnum,
  Supplier
} from "@/types/purchase";
import { App, Button, Checkbox, DatePicker, Flex, Input, Select, Tooltip, Modal, Tabs, Spin, Progress, notification, Upload, Space, UploadProps, Dropdown, TableProps } from "antd";
import { FC, useCallback, useContext, useEffect, useMemo, useRef, useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import useDataList from "@/hooks/useDataList";
import api, {
  ItemListParams,
  PrintStateEnum,
  itemUpdateByKey,
  finishStateUpdate,
  itemFetchs
} from "@/apis/purchase";
import {
  CommonListParams,
  SourceTypeEnum,
  PaginationParams
} from "@/types/common";
import useDataUpdate from "@/hooks/useDataUpdate";
import useDataAdd from "@/hooks/useDataAdd";
import useDataDel from "@/hooks/useDataDel";
import useFrontDelTip from "@/hooks/useFrontDelTip";
import STableLayout, {
  DEFAULT_PAGE_SIZE,
  TableLayoutRef
} from "@/styles/STableLayout";
import { ColumnsType } from "antd/lib/table";
import { productList } from "@/apis/product";
import { AnyObject } from "antd/lib/_util/type";
import { isEqualVal } from "@/utils/dataDeal";
import PurchaseAddOrEdit from "./PurchaseAddOrEdit";
import { CustomTabPaneContext } from "@/components/TabPane";
import useOrderColumn, { FILTER_PAGE_IDS } from "../hooks/useOrderColumn";
import useMaterialTrackingColumn from "../hooks/useMaterialTrackingColumn";
import { ChangeEnum, ConfirmedEnum, OperateEnum } from "@/types/inventory";
import ChangeForm from "@/pages/Warehouse/components/ChangeForm";
import { hasPermission, isAdmin } from "@/utils/user";
import { User, UserPermissionEnum } from "@/types/user";
import { RootState } from "@/store";
import { useSelector } from "react-redux";
import PrintOrderList from "./PrintOrderList";
import SupplierSelect from "@/pages/Purchase/components/SupplierSelect";
import dayjs, { Dayjs } from "dayjs";
import { DownOutlined } from "@ant-design/icons";
import usePage from "@/layout/hooks/usePage";
import { PageId } from "@/types/page";
import { dateFormat, priceFormat } from "@/utils/format";
import PurchaseDetail from "./PurchaseDetail";
import { RequirementItem } from "@/types/requirement";
import { Requirement } from "@/types/requirement";
import RequirementDetail from "@/pages/Requirement/pages/Detail";
import QuoteProgressDetail from "@/pages/Requirement/pages/Detail/components/QuoteProgressDetail";
import InventoryForm from "./InventoryForm";
import { Product } from "@/types/product";
import { acceptStateUpdate } from "@/apis/supplier";
import { exportFileUrl } from "@/apis/file";
import { orderAdd, orderLotUpdate } from "@/apis/inventoryv2";
import { OrderAddV2, OrderItemV2, OrderV2 } from "@/types/inventoryV2";
import MultiInventory from "./MultiInventory";
import ExportExcelButton from "@/components/ExportExcelButton";
import ExportProgressModal from "@/components/ExportProgressModal";
import { DictContext } from "@/layout/context/DictContext";
import { divided } from "@/utils/calc";
import { numFormmater } from "@/pages/Requirement/util";
import BatchPurchaseQCPrint from "./BatchPurchaseQCPrint";
import PrintInventoryV2, { PrintType } from "@/SupplierPages/Home/InventoryOrder/components/PrintInventoryV2";
import { SConModal } from "@/styles/SConModal";
import { downloadTemplate, parseExcelTemplate } from "./MultiInventoryImport/utils";
import MatchSupplierOrder from "./MatchSupplierOrder";
import { ItemType } from "antd/es/menu/interface";
import BatchCompleteTable from "./BatchCompleteTable";
import useBatchCompleteTable, {
  BatchCompleteFetchResult,
  DEFAULT_BATCH_ORDER_STATES
} from "./BatchCompleteTable/useBatchCompleteTable";
import PurSwapSale from "./PurSwapSale";
import { SaleOrderItemState } from "@/types/sales";
import { generateLotV2 } from "@/utils/codeParse";
import ListFilterBar from "@/components/ListFilterBar";
import useCommittedFilters from "@/components/ListFilterBar/hooks/useCommittedFilters";
const { RangePicker } = DatePicker;

const VISIBLE_ORDER_STATES = [
  PurchaseOrderStateEnum.PAY_PENDING,
  PurchaseOrderStateEnum.PAYED,
];

const PAYED_PAGE_ORDER_STATES = [
  PurchaseOrderStateEnum.PAYED,
  PurchaseOrderStateEnum.DONE,
  PurchaseOrderStateEnum.COMPLETED
];

const getPayedPageOrderStates = (
  orderState: PurchaseOrderStateEnum | null,
): Array<PurchaseOrderStateEnum> => {
  if (orderState === null) return PAYED_PAGE_ORDER_STATES;
  if (orderState === PurchaseOrderStateEnum.DONE) {
    return [PurchaseOrderStateEnum.DONE, PurchaseOrderStateEnum.COMPLETED];
  }
  return [orderState];
};

const isPendingPayPage = (pageId?: PageId) => pageId === PageId.PUR_ORDER_PENDING_PAY;

interface PurchaseOrderFilters {
  keyword: string;
  orderState: PurchaseOrderStateEnum | null;
  startTime: Dayjs | null;
  endTime: Dayjs | null;
  supplierId: string;
  deliveryDeadline: Dayjs | null;
  finishState?: PurchasefFnishStateEnum;
  inState?: PurchasefInStateEnum;
}

const INITIAL_PURCHASE_ORDER_FILTERS: PurchaseOrderFilters = {
  keyword: "",
  orderState: null,
  startTime: null,
  endTime: null,
  supplierId: "",
  deliveryDeadline: null,
  finishState: undefined,
  inState: undefined,
};

const PurchaseOrderList: FC = () => {
  const { t } = useTranslation();
  const { curUser } = useSelector((state: RootState) => state.userReducer)
  const { modal } = App.useApp();
  const { onOpen } = useContext(CustomTabPaneContext);
  const { pageId } = usePage();
  const currentUser: User = useSelector(
    (state: RootState) => state.userReducer.curUser
  );
  const { currencys, salePayMethod } = useContext(DictContext);
  const tableRef = useRef<TableLayoutRef | null>(null);
  const abortControllerRef = useRef<AbortController | null>(null);

  const [payedLoading, setPayedLoading] = useState<boolean>(false);
  const [uploading, setUploading] = useState<boolean>(false);
  const [uploadingProgress, setUploadingProgress] = useState<number>(0);
  const [openSwap, setOpenSwap] = useState<boolean>(false);

  const [
    list,
    total,
    listLoading,
    { fetchList, addItem, rmItem, rmItems, updateItem, updateItems }
  ] = useDataList<PurchaseOrderItem, [CommonListParams<ItemListParams>]>({
    fetchApi:
      pageId &&
        [PageId.PUR_ORDER_PAYED, PageId.PUR_HELP_ACCEPT, PageId.PUR_ORDER_DONE].includes(pageId)
        ? api.itemFetchs
        : pageId === PageId.PUR_ZF
          ? api.itemZFList
          : pageId === PageId.PUR_RT
            ? api.hasReturn
            : api.itemList
  });
  const { update, loading: updateLoading } = useDataUpdate<
    [string, PurchaseOrderAdd]
  >({ api: api.update });
  const { update: updateSaleItem, loading: updateItemLoading } = useDataUpdate<
    [string, PurchaseOrderAddItem]
  >({ api: api.itemUpdate });
  const { add, loading: addLoading } = useDataAdd<
    [PurchaseOrderAdd],
    PurchaseOrder
  >({ api: api.add });
  const { del } = useDataDel({ api: api.itemDel });

  const {
    draftFilters,
    appliedFilters,
    updateDraftFilters,
    commitFilters,
    replaceFilters,
  } = useCommittedFilters(INITIAL_PURCHASE_ORDER_FILTERS);
  const {
    keyword,
    orderState,
    startTime,
    endTime,
    supplierId,
    deliveryDeadline,
    finishState,
    inState,
  } = draftFilters;

  const [printState, setPrintState] = useState<PrintStateEnum>(
    PrintStateEnum.UN_PRINT
  );
  const [addOpen, setAddOpen] = useState<boolean>(false);
  const [printLoading, setPrintLoading] = useState<boolean>(false);
  const [inOrder, setInOrder] = useState<PurchaseOrderItem | null>(null);
  const [detail, setDetail] = useState<PurchaseOrderItem | null>(null);
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [selectedRows, setSelectRows] = useState<PurchaseOrderItem[]>([]);
  const listRef = useRef<PurchaseOrderItem[]>([]);
  const selectedRowKeysRef = useRef<React.Key[]>([]);
  const selectedPendingPayRowsRef = useRef<Map<string, PurchaseOrderItem>>(new Map());
  const [showDetail, setShowDetail] = useState<PurchaseOrderItem | null>(null);
  const [preOrder, setPreOrder] = useState<PurchaseOrderItem | null>(null);
  const [requirementDetail, setRequirementDetail] = useState<RequirementItem | null>(null)
  const [requirementData, setRequirementData] = useState<Requirement | null>(null)
  const [reloading, setPreloading] = useState<boolean>(false)
  const [openImport, setOpenImport] = useState<boolean>(false)
  const [multiInventoryOpen, setMultiInventoryOpen] = useState<boolean>(false);
  const { onConfirm } = useFrontDelTip({
    cb: (id: string) => onDel(id),
    message: t("purchase.delTips"),
    desc: t("purchase.delContent")
  });
  const { onConfirm: onReject } = useFrontDelTip({
    cb: (oldItem: PurchaseOrderItem, orderId: string) =>
      updateAccStatus(oldItem, orderId, 0),
    message: t("common.tip"),
    desc: t("purchase.rejectComfi")
  });
  const { onConfirm: onAccept } = useFrontDelTip({
    cb: (oldItem: PurchaseOrderItem, orderId: string) =>
      updateAccStatus(oldItem, orderId, 1),
    message: t("common.tip"),
    desc: t("purchase.comfi")
  });
  const { onConfirm: onRePrint } = useFrontDelTip({
    cb: (id: string, rowId: string) => rePrint(id, rowId),
    message: t("common.tip"),
    desc: t("purchase.rePrtCon")
  });
  const { onConfirm: onCompletedProduction } = useFrontDelTip({
    cb: async (id: string, value: PurchaseOrderStateEnum) => {
      await itemUpdateByKey(id, { key: "orderState", value });
      removeCompletedOrdersFromCurrentView([id]);
    },
    message: t("common.tip"),
    desc: t("purchase.confirmCompletedProduction")
  });

  const [loadingId, setLoadingId] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);
  const [exportLoading, setExportLoading] = useState<boolean>(false);
  const [exportProgress, setExportProgress] = useState<number>(0);

  // 与销售正式订单一致：勾选阶段只存 id，点击操作时再按 id 从最新列表取完整行。
  listRef.current = list;
  selectedRowKeysRef.current = selectedRowKeys;

  useEffect(() => {
    const selectedIdSet = new Set(selectedRowKeysRef.current.map(String));
    // 跨页选中时，当前页重新请求后用最新行对象覆盖缓存，避免下单使用旧数据。
    list.forEach(item => {
      const id = String(item.id);
      if (selectedIdSet.has(id)) {
        selectedPendingPayRowsRef.current.set(id, item);
      }
    });
  }, [list]);


  // 从订单列表中提取唯一的供应商信息，避免调用 /wms/supplier/list 接口
  // const supplierList = useMemo(() => {
  //   if (!list || list.length === 0) return [];

  //   // 从 list 中提取所有供应商
  //   const suppliers = list
  //     .map(item => item?.order?.supplier)
  //     .filter((supplier): supplier is Supplier => !!supplier && !!supplier.id);

  //   // 按 ID 去重
  //   const supplierMap = new Map<string, Supplier>();
  //   suppliers.forEach(supplier => {
  //     supplierMap.set(supplier.id, supplier);
  //   });

  //   // 按 code 或 name 排序
  //   return Array.from(supplierMap.values()).sort((a, b) => {
  //     const aKey = a.shortName || a.name || a.code || '';
  //     const bKey = b.shortName || b.name || b.code || '';
  //     return aKey.localeCompare(bKey);
  //   });
  // }, [list]);

  const rePrint = (id: string, rowId: string) => {
    return new Promise<void>((resolve, reject) => {
      api
        .rePrint(id)
        .then(() => {
          if (printState === PrintStateEnum.PRINTED) rmItem(rowId)
          else {
            setTimeout(() => {
              let row = list.find(item => item.id === rowId)!;
              updateItem({
                ...row,
                printItem: null
              })
            }, 300);
          }
          notification.success({
            placement: 'top',
            message: t("order.operationSucc"),
            description: t("purchase.plRePrt")
          });
          return resolve();
        })
        .catch(() => {
          notification.error({ placement: 'top', message: t("order.optErr") });
          return reject();
        });
    });
  };

  const removeCompletedOrdersFromCurrentView = (ids: string[]) => {
    const removedIdSet = new Set(ids);
    rmItems(ids);
    setSelectedRowKeys(prev => prev.filter(key => !removedIdSet.has(String(key))));
    setSelectRows(prev => prev.filter(row => !removedIdSet.has(row.id)));
    ids.forEach(id => selectedPendingPayRowsRef.current.delete(String(id)));
  };

  // 点击下单时再读取完整行对象，避免勾选时把重对象写入 state。
  const getSelectedPurchaseRows = useCallback(() => {
    return selectedRowKeysRef.current
      .map(id => {
        const key = String(id);
        return selectedPendingPayRowsRef.current.get(key) ?? listRef.current.find(item => String(item.id) === key);
      })
      .filter(Boolean) as Array<PurchaseOrderItem>;
  }, []);

  const handleFinishStateUpdate = async (record: PurchaseOrderItem, targetState: PurchasefFnishStateEnum) => {
    const status = targetState === PurchasefFnishStateEnum.UN_FINISHED
      ? t("purchase.pendingProduction")
      : targetState === PurchasefFnishStateEnum.FINISHING
        ? t("purchase.inProduction")
        : t("purchase.finishedProduction");

    modal.confirm({
      title: t("common.tip"),
      content: (
        <Trans
          i18nKey="purchase.confirmMarkAsStatus"
          values={{ status }}
          components={{ strong: <strong /> }}
        />
      ),
      onOk: async () => {
        try {
          setLoadingId(record.id);
          await finishStateUpdate(record.id, targetState);
          notification.success({ placement: 'top', message: t("sale.updateSuccess") });
          // 调用 rmItem 移除该项
          updateItem({ ...record, finishState: targetState });
        } catch (error) {
          notification.error({ placement: 'top', message: t("common.updateError") });
        } finally {
          setLoadingId("");
        }
      }
    });
  };

  const baseColumns = useOrderColumn({
    onDetail: setDetail,
    onDel: onConfirm,
    onOpenTab: onOpen,
    onIn: setInOrder,
    onAccept,
    onReject,
    onRePrint,
    onCompletedProduction,
    setShowDetail: (data) => setShowDetail(data),
    setPreOrder: (data) => setPreOrder(data),
    onOpenRequirementDetail: (requirement) => setRequirementData(requirement)
  });

  const materialTrackingColumns = useMaterialTrackingColumn({
    onDetail: setDetail,
    onDel: onConfirm,
    onOpenTab: onOpen,
    onIn: setInOrder,
    onAccept,
    onReject,
    onRePrint,
    onCompletedProduction,
    setShowDetail: (data) => setShowDetail(data),
    setPreOrder: (data) => setPreOrder(data),
    onOpenRequirementDetail: (requirement) => setRequirementData(requirement)
  });

  const columns = useMemo(() => {
    if (pageId === PageId.PUR_MT) {
      return [
        ...materialTrackingColumns,
        {
          title: t("common.opt"),
          key: "materialTrackingOperation",
          dataIndex: "operation",
          width: 160,
          fixed: "right",
          render: (_: any, record: PurchaseOrderItem) => (
            <Flex justify="flex-start" gap={6}>
              {record.order?.acceptState === AcceptStateEnum.RESOLVED && (
                <Button
                  type="primary"
                  size="small"
                  onClick={() => setPreOrder(record)}
                >
                  {t("purchase.delivery")}
                </Button>
              )}
              <Dropdown
                menu={{
                  items: [
                    {
                      key: String(PurchasefFnishStateEnum.UN_FINISHED),
                      label: t("purchase.pendingProduction")
                    },
                    {
                      key: String(PurchasefFnishStateEnum.FINISHING),
                      label: t("purchase.inProduction")
                    },
                    {
                      key: String(PurchasefFnishStateEnum.FINISHED),
                      label: t("purchase.finishedProduction"),
                    }
                  ],
                  onClick: ({ key }) => handleFinishStateUpdate(
                    record,
                    Number(key) as PurchasefFnishStateEnum
                  )
                }}
                disabled={loadingId === record.id}
                trigger={['click']}
              >
                <Button
                  type="primary"
                  size="small"
                  icon={<DownOutlined />}
                  loading={loadingId === record.id}
                >
                  {t("purchase.selectStatus")}
                </Button>
              </Dropdown>
            </Flex>
          )
        }
      ];
    }
    return baseColumns;
  }, [baseColumns, loadingId, materialTrackingColumns, pageId, t]);

  // 批量完结列
  const batchCompleteColumns = useMemo(
    () =>
      columns.filter(column => {
        if (!("dataIndex" in column)) return true;

        const dataIndex = Array.isArray(column.dataIndex)
          ? column.dataIndex.join(".")
          : column.dataIndex;

        return !["dsa", "relatedDocuments", "operation"].includes(
          String(dataIndex ?? "")
        );
      }),
    [columns]
  );

  const batchCompleteTable = useBatchCompleteTable({
    fetchData: async ({
      offset,
      take,
      printState,
      // finishState,
      orderState,
      inState,
      supplierId,
      keyword,
      startTime,
      endTime,
      controller
    }): Promise<BatchCompleteFetchResult> => {
      const res = await api.itemFetchs({
        body: {
          supplierId: supplierId ?? "",
          keyword: keyword ?? "",
          orderStates: orderState != null ? [orderState] : DEFAULT_BATCH_ORDER_STATES,
          inState,
          printState,
          // finishState: finishState
        },
        startTime: startTime ? startTime.startOf("day").valueOf() : undefined,
        endTime: endTime ? endTime.endOf("day").valueOf() : undefined,
        pagination: { offset, take },
        controller
      });

      return {
        list: res.body ?? [],
        total: res.pagination?.size ?? 0
      };
    },
    submitData: async (rows) => {
      for (const row of rows) {
        await itemUpdateByKey(row.id, {
          key: "orderState",
          value: PurchaseOrderStateEnum.COMPLETED
        });
      }
    },

    onCompleted: rows => {
      removeCompletedOrdersFromCurrentView(rows.map(row => row.id));
    },
  });

  // ✅ pageId 变化时取消请求
  useEffect(() => {
    return () => {
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }
    };
  }, [pageId]);


  useEffect(() => {
    if (!pageId) return;

    const nextFilters = replaceFilters({
      ...appliedFilters,
      endTime: [
        PageId.PUR_ORDER_PENDING_PAY,
        PageId.PUR_ORDER_PAYED,
      ].includes(pageId)
        ? dayjs()
        : null,
    });
    fetch(0, nextFilters);
    tableRef?.current?.resetTablePage();
    // 这里只在页面或打印状态变化时自动刷新。
  }, [pageId, printState]);

  const updateAccStatus = (
    oldItem: PurchaseOrderItem,
    orderId: string,
    status: 0 | 1
  ) => {
    return new Promise<void>((resolve, reject) => {
      acceptStateUpdate(orderId, status)
        .then(res => {
          updateItem({ ...oldItem, order: { ...res } });
          notification.success({
            placement: 'top',
            message:
              status === 1 ? t("purchase.helpAccSuc") : t("purchase.helpRejSuc")
          });
          resolve();
        })
        .catch(() => {
          reject();
        });
    });
  };

  const onDel = (id: string) => {
    return del(id)
      .then(() => {
        rmItem(id);
        notification.success({ placement: 'top', message: t("order.operationSucc") });
      })
      .catch(() => {
        notification.error({ placement: 'top', message: t("order.optErr") });
      });
  };

  const fetchProductApi = (
    ...args: [string, CommonListParams]
  ): Promise<{
    body: Product[];
    pagination: PaginationParams | undefined;
  }> => {
    return productList();
  };

  // 导出列配置
  const exportColumns = (t: any) => [
    { key: "purchase.orderNumber", label: t("purchase.orderNumber") },
    { key: "sale.requirement", label: t("sale.requirement") },
    { key: "purchase.code", label: t("purchase.code") },
    { key: "purchase.name", label: t("purchase.name") },
    { key: "purchase.count", label: t("purchase.count") },
    { key: "purchase.amount", label: t("purchase.amount") },
    { key: "purchase.rateAmount", label: t("purchase.rateAmount") },
    { key: "purchase.spareRate", label: t("purchase.spareRate") },
    { key: "purchase.spareCount", label: t("purchase.spareCount") },
    { key: "purchase.orderTime", label: t("purchase.orderTime") },
    { key: "purchase.deliveryDeadline", label: t("purchase.deliveryDeadline") },
    { key: "purchase.deliveredQuantity", label: t("purchase.deliveredQuantity") },
    { key: "purchase.returnQty", label: t("purchase.returnQty") },
    { key: "purchase.actualArrivalQty", label: t("purchase.actualArrivalQty") },
    { key: "purchase.undeliveredQty", label: t("purchase.undeliveredQty") },
    { key: "purchase.actualArrivalTime", label: t("purchase.actualArrivalTime") },
    { key: "purchase.actualInboundTime", label: t("purchase.actualInboundTime") },
    { key: "purchase.currency", label: t("purchase.currency") },
    { key: "purchase.payMethod", label: t("purchase.payMethod") },
    { key: "purchase.orderDesc", label: t("purchase.orderDesc") },
    { key: "purchase.productDesc", label: t("purchase.productDesc") },
    { key: "product.code", label: t("product.code") },
    { key: "product.name", label: t("product.name") },
    { key: "product.brand1", label: t("product.brand1") },
    { key: "product.brand2", label: t("product.brand2") },
    { key: "product.uom", label: t("product.uom") },
    { key: "common.desc", label: t("common.desc") },
    { key: "purchase.stPrice", label: t("purchase.stPrice") },
    { key: "purchase.state", label: t("purchase.state") },
    { key: "purchase.deliveryStatus", label: t("purchase.deliveryStatus") },
    { key: "purchase.orderState", label: t("purchase.orderState") },
    { key: "purchase.deliveryProgress", label: t("purchase.deliveryProgress") },
    { key: "purchase.brand", label: t("purchase.brand") },
    { key: "purchase.mpn", label: t("purchase.mpn") },
    { key: "purchase.dcc", label: t("purchase.dcc") }
  ];

  const getInboundTime = (item: PurchaseOrderItem) => {
    let res: string = '';
    let inventories = item.inventoryItems || [];
    if (inventories.length === 0) res = ''
    if (inventories.length === 1) res = inventories[0].order.confirmedAt ? dateFormat(dayjs(inventories[0].order.confirmedAt)) : ''
    if (inventories.length > 1) {
      let validData = inventories.filter(inv => !!inv.count && !!inv.order.confirmedAt);
      if (validData.length === 1) res = dateFormat(dayjs(validData[0].order.confirmedAt))
      if (validData.length > 1) res = validData.map(vd => `${vd.order.number} ${dateFormat(dayjs(vd.order.confirmedAt))} ${vd.count}`).join(' \n')
    }
    return res;
  }

  // 默认选中的列
  const defaultSelectedColumns = (t: any) => [
    "purchase.orderNumber",
    "purchase.code",
    "purchase.count",
    "purchase.deliveryDeadline",
    "purchase.actualInboundTime",
    "product.code",
    "product.name",
    "product.brand1",
    "product.uom"
  ];

  // 导出数据映射函数
  const exportDataMapper = (item: PurchaseOrderItem, t: any) => {
    let amountPrice = '';
    const taxRate = item.quotationRequest?.price?.taxRate || item.taxRate;
    if (taxRate && item.rateAmount) {
      const rate = divided(taxRate ?? '0', '100')
      amountPrice = divided(item.rateAmount, (1 + Number(rate)).toString())
    }
    const sPrice = Number(
      item.quotationRequest && item.quotationRequest.supplierPrice
        ? String(item.quotationRequest.supplierPrice)
        : item?.price?.price || ""
    );

    let purState = item.order?.acceptState === null ? t("purchase.pend")
      : item.order?.acceptState === AcceptStateEnum.RESOLVED ? t("purchase.acceptType")
        : t("purchase.rejectType")
    let deliveryStatus = item.finishState === PurchasefFnishStateEnum.UN_FINISHED ? t("purchase.pendingProduction")
      : item.finishState === PurchasefFnishStateEnum.FINISHING ? t("purchase.inProduction")
        : item.finishState === PurchasefFnishStateEnum.FINISHED ? t("purchase.finishedProduction")
          : '-';
    const orderState = item.orderState === PurchaseOrderStateEnum.PAY_PENDING ? t("purchase.notPurchase")
      : item.orderState === PurchaseOrderStateEnum.PAYED ? t("purchase.purchased")
        : item.orderState === PurchaseOrderStateEnum.DONE ? t("layout.purDone")
          : item.orderState === PurchaseOrderStateEnum.COMPLETED ? t("purchase.completedProduction")
            : '-';

    let sum = item.inventoryItems ? item.inventoryItems.length : 0;
    let count = 0;
    item.inventoryItems && item.inventoryItems.forEach((i: OrderItemV2) => {
      if (i.order.confirmState === ConfirmedEnum.CONFIRM) count++
    })
    let deliveryProgress = `${count}/${sum}`
    const actualArrivalTime = item.inventoryItems && item.inventoryItems.length > 0
      ? item.inventoryItems
        .map(inv => {
          const orderNumber = inv.order?.number || "";
          const arrivalAt = inv.order?.arrivalAt
            ? dayjs(inv.order.arrivalAt).format("YYYY-MM-DD")
            : "";
          const quantity = numFormmater(Number(inv.count || 0));
          if (!arrivalAt) return "";
          return `${orderNumber} ${arrivalAt} ${quantity}`;
        })
        .filter(Boolean)
        .join("\n")
      : "";
    const actualInboundTime = getInboundTime(item);
    return {
      [t("purchase.orderNumber")]: item?.number || "",
      [t("sale.requirement")]:
        item.quotationRequest &&
          item.quotationRequest &&
          item.quotationRequest.requirementItem
          ? item.quotationRequest.requirementItem.requirement.number
          : "",
      [t("purchase.code")]: item?.order?.supplier?.code || "",
      [t("purchase.name")]: item?.order?.supplier?.name || "",
      [t("purchase.count")]: item?.count?.toString() || "",
      [t("purchase.amount")]: amountPrice ? numFormmater(Number(amountPrice)) : "",
      [t("purchase.rateAmount")]: priceFormat(item?.rateAmount),
      [t("purchase.spareRate")]: numFormmater(Number(item?.spareRate || 0)),
      [t("purchase.spareCount")]: numFormmater(Number(item?.spareCount || 0)),
      [t("purchase.orderTime")]: item.orderTime
        ? dateFormat(dayjs(item.orderTime))
        : "",
      [t("purchase.deliveryDeadline")]: item.deliveryDeadline
        ? dateFormat(dayjs(item.deliveryDeadline))
        : "",
      [t("purchase.deliveredQuantity")]: numFormmater(item.deliveredQuantity || 0),
      [t("purchase.returnQty")]: numFormmater(item.returnCount || 0),
      [t("purchase.actualArrivalQty")]: numFormmater((item.deliveredQuantity || 0) - (item.returnCount || 0)),
      [t("purchase.undeliveredQty")]: numFormmater(Math.max(0, (item.count || 0) - (item.deliveredQuantity || 0) + (item.returnCount || 0))),
      [t("purchase.actualArrivalTime")]: actualArrivalTime,
      [t("purchase.actualInboundTime")]: actualInboundTime,
      [t("purchase.currency")]: currencys.find(
        currency => currency.key === item?.order.currency
      )?.desc,
      [t("purchase.payMethod")]: salePayMethod.find(
        salePay => salePay.id === item?.order.payMethod
      )?.key,
      [t("purchase.orderDesc")]: item?.order?.remark || "",
      [t("purchase.productDesc")]: item.remark || "",
      [t("product.code")]: item?.product?.code || "",
      [t("product.name")]: item?.product?.name || "",
      [t("product.brand1")]: item?.product?.model || "",
      [t("product.brand2")]: item?.product?.t1 || "",
      [t("product.uom")]: item?.product?.uom || "",
      [t("common.desc")]: item?.product?.desc || "",
      [t("purchase.stPrice")]: numFormmater(sPrice),
      [t("purchase.state")]: purState,
      [t("purchase.deliveryStatus")]: deliveryStatus,
      [t("purchase.orderState")]: orderState,
      [t("purchase.deliveryProgress")]: deliveryProgress,
      [t("purchase.brand")]: item?.brand || "",
      [t("purchase.mpn")]: item?.mpn || "",
      [t("purchase.dcc")]: item?.quotationRequest?.price?.dcc || "",
    };
  };

  const fetch = (
    offset: number,
    filters: PurchaseOrderFilters,
  ) => {
    // ✅ 取消上一次请求
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }

    // ✅ 创建新的 AbortController
    const controller = new AbortController();
    abortControllerRef.current = controller;

    const take = tableRef.current?.pageSize ?? DEFAULT_PAGE_SIZE;
    const orderStates =
      pageId === PageId.PUR_ORDER_PENDING_PAY
        ? [PurchaseOrderStateEnum.PAY_PENDING]
        : pageId === PageId.PUR_ORDER_PAYED
          ? getPayedPageOrderStates(filters.orderState)
          : pageId === PageId.PUR_HELP_ACCEPT
            ? [PurchaseOrderStateEnum.PAYED]
            : pageId === PageId.PUR_ORDER_DONE
              ? [PurchaseOrderStateEnum.DONE, PurchaseOrderStateEnum.COMPLETED]
              : pageId === PageId.PUR_MT
                ? VISIBLE_ORDER_STATES
                : undefined;
    const requestParams = {
      body: {
        supplierId: filters.supplierId,
        keyword: filters.keyword,
        orderStates,
        printState:
          pageId && pageId === PageId.PUR_ORDER_PAYED
            ? printState
            : undefined,
        finishState:
          pageId === PageId.PUR_ORDER_PAYED || pageId === PageId.PUR_MT
            ? filters.finishState
            : undefined,
        inState:
          pageId === PageId.PUR_ORDER_PAYED ? filters.inState : undefined,
        deliveryDeadline:
          pageId === PageId.PUR_MT
            ? filters.deliveryDeadline?.endOf("day")?.valueOf()
            : undefined
      },
      startTime:
        pageId === PageId.PUR_MT
          ? undefined
          : filters.startTime
            ? filters.startTime.startOf("day").valueOf()
            : undefined,
      endTime:
        pageId === PageId.PUR_MT
          ? undefined
          : filters.endTime
            ? filters.endTime.endOf("day").valueOf()
            : undefined
    };
    fetchList({
      body: requestParams.body,
      pagination: { offset, take },
      startTime: requestParams.startTime,
      endTime: requestParams.endTime,
      controller, // ✅ 传递 controller 用于取消请求
    }).catch(err => {
      // ✅ 忽略取消的请求
      if (err?.name === 'AbortError') {
        return;
      }
      const map: {
        [key in number]: string;
      } = {
        10010: t("common.networkError"),
        69001: t("common.serverError")
      };
      notification.error({
        placement: 'top',
        message: t("common.searchError"),
        description: map[err] ?? t("common.serverError")
      });
    });
  };

  const handleSearch = () => {
    const nextFilters = commitFilters();
    tableRef?.current?.resetTablePage();
    fetch(0, nextFilters);
  };

  const handleClearFilters = () => {
    const nextFilters = replaceFilters(INITIAL_PURCHASE_ORDER_FILTERS);
    tableRef?.current?.resetTablePage();
    fetch(0, nextFilters);
  };

  const onOrders = useCallback(async () => {
    const orderRows = getSelectedPurchaseRows();
    if (orderRows.length === 0) return;
    let checked = false;
    modal.confirm({
      title: t("order.ordersComfirm"),
      width: 400,
      content: (
        <Checkbox
          onChange={(e) => { checked = e.target.checked }}
        >
          {t('purchase.helpAcc')}
        </Checkbox>
      ),
      okButtonProps: { loading: payedLoading },
      onOk: async () => {
        setPayedLoading(true);
        for (let i = 0; i < orderRows.length; i++) {
          await api.itemUpdateByKey(orderRows[i].id + '', {
            key: "orderState",
            value: PurchaseOrderStateEnum.PAYED
          });
          if (checked) {
            await acceptStateUpdate(orderRows[i]?.orderId ?? '', 1);
          }
          rmItem(orderRows[i].id)
        }
        notification.success({ message: t('order.operationSucc'), description: checked ? t('purchase.helpAccSuc') : undefined });
        setPayedLoading(false);
        setSelectedRowKeys([]);
        setSelectRows([]);
        selectedPendingPayRowsRef.current.clear();
      }
    });
  }, [getSelectedPurchaseRows, modal, payedLoading, rmItem, t]);

  const handleMultiDown = () => {
    if (selectedRows?.length > 0) {
      let fileIds: string[] = [];
      selectedRows.forEach(purItem => {
        if (purItem?.printItem?.order?.fileId)
          fileIds.push(purItem.printItem.order.fileId);
      });
      if (fileIds.length > 0)
        window.open(exportFileUrl(fileIds.join(",")), "_self");
    } else {
      notification.error({
        placement: 'top',
        message: t("purchase.downErr"),
        description: t("purchase.leastOne")
      });
    }
  };

  const handleExportAll = async (): Promise<PurchaseOrderItem[]> => {
    const batchSize = 100;
    const allDataList: PurchaseOrderItem[] = [];
    const filters = appliedFilters;

    // 根据 pageId 确定订单状态和使用的API
    let orderStates: Array<PurchaseOrderStateEnum> | undefined;
    let useItemList = false; // 标记是否使用 itemList 接口

    if (pageId === PageId.PUR_ORDER_PAYED) {
      orderStates = getPayedPageOrderStates(filters.orderState);
    } else if (pageId === PageId.PUR_HELP_ACCEPT) {
      orderStates = [PurchaseOrderStateEnum.PAYED];
    } else if (pageId === PageId.PUR_ORDER_DONE) {
      orderStates = [PurchaseOrderStateEnum.DONE, PurchaseOrderStateEnum.COMPLETED];
    } else if (pageId === PageId.PUR_MT) {
      orderStates = VISIBLE_ORDER_STATES;
      useItemList = true; // 齐料追踪使用 itemList
    } else {
      throw new Error("Unsupported pageId for export all");
    }

    setExportLoading(true);
    setExportProgress(0);

    try {
      // 先发起第一次请求获取总条数
      const apiMethod = useItemList ? api.itemList : api.itemFetchs;
      const firstRes = await apiMethod({
        body: {
          supplierId: filters.supplierId,
          keyword: filters.keyword,
          orderStates,
          printState:
            pageId && pageId === PageId.PUR_ORDER_PAYED
              ? printState
              : undefined,
          finishState: pageId === PageId.PUR_ORDER_PAYED || pageId === PageId.PUR_MT
            ? filters.finishState
            : undefined,
          inState:
            pageId === PageId.PUR_ORDER_PAYED ? filters.inState : undefined,
          deliveryDeadline:
            pageId === PageId.PUR_MT
              ? filters.deliveryDeadline?.endOf("day")?.valueOf()
              : undefined
        },
        startTime:
          pageId === PageId.PUR_MT
            ? undefined
            : filters.startTime
              ? filters.startTime.startOf("day").valueOf()
              : undefined,
        endTime:
          pageId === PageId.PUR_MT
            ? undefined
            : filters.endTime
              ? filters.endTime.endOf("day").valueOf()
              : undefined,
        pagination: { offset: 0, take: batchSize }
      });

      if (firstRes?.body) {
        allDataList.push(...firstRes.body);
      }

      // 根据返回的 pagination.size 计算总批次数
      const totalSize = firstRes?.pagination?.size ?? 0;
      const batches = Math.ceil(totalSize / batchSize);

      // 继续请求剩余数据
      for (let i = 1; i < batches; i++) {
        // 更新进度
        setExportProgress(Math.round(((i + 1) / batches) * 100));

        const offset = i * batchSize;
        const res = await apiMethod({
          body: {
            supplierId: filters.supplierId,
            keyword: filters.keyword,
            orderStates,
            printState:
              pageId && pageId === PageId.PUR_ORDER_PAYED
                ? printState
                : undefined,
            finishState: pageId === PageId.PUR_ORDER_PAYED || pageId === PageId.PUR_MT
              ? filters.finishState
              : undefined,
            inState:
              pageId === PageId.PUR_ORDER_PAYED ? filters.inState : undefined,
            deliveryDeadline:
              pageId === PageId.PUR_MT
                ? filters.deliveryDeadline?.endOf("day")?.valueOf()
                : undefined
          },
          startTime:
            pageId === PageId.PUR_MT
              ? undefined
              : filters.startTime
                ? filters.startTime.startOf("day").valueOf()
                : undefined,
          endTime:
            pageId === PageId.PUR_MT
              ? undefined
              : filters.endTime
                ? filters.endTime.endOf("day").valueOf()
                : undefined,
          pagination: { offset, take: batchSize }
        });
        if (res?.body) {
          allDataList.push(...res.body);
        }
      }

      const filteredData = allDataList.filter(
        order => order?.order?.acceptState !== AcceptStateEnum.REJECTED
      );
      return filteredData;
    } catch (error) {
      const totalSize = allDataList.length;
      const filteredSize = allDataList.filter(
        order => order?.order?.acceptState !== AcceptStateEnum.REJECTED
      ).length;
      const rejectedCount = totalSize - filteredSize;
      notification.error({
        placement: 'top',
        message: t("common.exportErr"),
        description: `${t("requirement.total")}: ${totalSize}, ${t(
          "requirement.success"
        )}: ${filteredSize}, ${t("requirement.failed")}: ${rejectedCount}`
      });
      throw error;
    } finally {
      setExportLoading(false);
      setExportProgress(0);
    }
  };

  const handleExportAllReturn = async (): Promise<PurchaseOrderItem[]> => {
    const batchSize = 100;
    const allDataList: PurchaseOrderItem[] = [];
    const filters = appliedFilters;

    setExportLoading(true);
    setExportProgress(0);

    try {
      // 先发起第一次请求获取总条数
      const firstRes = await api.hasReturn({
        body: {
          supplierId: filters.supplierId,
          keyword: filters.keyword
        },
        startTime: filters.startTime
          ? filters.startTime.startOf("day").valueOf()
          : undefined,
        endTime: filters.endTime
          ? filters.endTime.endOf("day").valueOf()
          : undefined,
        pagination: { offset: 0, take: batchSize }
      });

      if (firstRes?.body) {
        allDataList.push(...firstRes.body);
      }

      // 根据返回的 pagination.size 计算总批次数
      const totalSize = firstRes?.pagination?.size ?? 0;
      const batches = Math.ceil(totalSize / batchSize);

      // 继续请求剩余数据
      for (let i = 1; i < batches; i++) {
        const offset = i * batchSize;
        const res = await api.hasReturn({
          body: {
            supplierId: filters.supplierId,
            keyword: filters.keyword
          },
          startTime: filters.startTime
            ? filters.startTime.startOf("day").valueOf()
            : undefined,
          endTime: filters.endTime
            ? filters.endTime.endOf("day").valueOf()
            : undefined,
          pagination: { offset, take: batchSize }
        });
        if (res?.body) {
          allDataList.push(...res.body);
        }
        // 更新进度
        setExportProgress(Math.round(((i + 1) / batches) * 100));
      }

      return allDataList;
    } catch (error) {
      notification.error({
        placement: 'top',
        message: t("common.exportErr"),
        description: t("common.serverError")
      });
      throw error;
    } finally {
      setExportLoading(false);
      setExportProgress(0);
    }
  };

  const handleExportAllZF = async (): Promise<PurchaseOrderItem[]> => {
    const batchSize = 100;
    const allDataList: PurchaseOrderItem[] = [];
    const filters = appliedFilters;

    setExportLoading(true);
    setExportProgress(0);

    try {
      // 先发起第一次请求获取总条数
      const firstRes = await api.itemZFList({
        body: {
          supplierId: filters.supplierId,
          keyword: filters.keyword
        },
        startTime: filters.startTime
          ? filters.startTime.startOf("day").valueOf()
          : undefined,
        endTime: filters.endTime
          ? filters.endTime.endOf("day").valueOf()
          : undefined,
        pagination: { offset: 0, take: batchSize }
      });

      if (firstRes?.body) {
        allDataList.push(...firstRes.body);
      }

      // 根据返回的 pagination.size 计算总批次数
      const totalSize = firstRes?.pagination?.size ?? 0;
      const batches = Math.ceil(totalSize / batchSize);

      // 继续请求剩余数据
      for (let i = 1; i < batches; i++) {
        const offset = i * batchSize;
        const res = await api.itemZFList({
          body: {
            supplierId: filters.supplierId,
            keyword: filters.keyword
          },
          startTime: filters.startTime
            ? filters.startTime.startOf("day").valueOf()
            : undefined,
          endTime: filters.endTime
            ? filters.endTime.endOf("day").valueOf()
            : undefined,
          pagination: { offset, take: batchSize }
        });
        if (res?.body) {
          allDataList.push(...res.body);
        }
        // 更新进度
        setExportProgress(Math.round(((i + 1) / batches) * 100));
      }

      return allDataList;
    } catch (error) {
      notification.error({
        placement: 'top',
        message: t("common.exportErr"),
        description: t("common.serverError")
      });
      throw error;
    } finally {
      setExportLoading(false);
      setExportProgress(0);
    }
  };

  const selectInventories = useMemo(() => {
    let resItem: Array<OrderItemV2> = [];
    if (selectedRows && selectedRows.length > 0) {
      selectedRows.forEach(purItem => {
        if (purItem.inventoryItems && purItem.inventoryItems.length > 0) {
          resItem.push(
            ...purItem.inventoryItems.map(item => ({
              ...item,
              sourceType: SourceTypeEnum.PURCHASE_ITEM,
              source: { ...purItem }
            } as OrderItemV2))
          )
        }
      })
    }
    return resItem;
  }, [selectedRows])

  const headerChildren = (
    <ListFilterBar
      onSearch={handleSearch}
      onReset={handleClearFilters}
      disabled={listLoading}
    >
      {({ submit: submitFilters }) => (
        <>
          {
            pageId === PageId.PUR_ORDER_PENDING_PAY && hasPermission(curUser, [UserPermissionEnum.PUR_ORDER_ADD]) && (
              <Button type="primary" onClick={() => setAddOpen(true)} >
                {t('purchase.addPurchaseOrder')}
              </Button>
            )
          }
          {pageId === PageId.PUR_ORDER_PAYED && (
            <Select
              value={orderState}
              onChange={value =>
                updateDraftFilters({ orderState: value ?? null })
              }
              allowClear
              placeholder={t("purchase.orderState")}
              style={{ width: 120 }}
            >
              <Select.Option value={PurchaseOrderStateEnum.PAYED}>
                {t("purchase.purchased")}
              </Select.Option>
              <Select.Option value={PurchaseOrderStateEnum.DONE}>
                {t("layout.purDone")}/{t("purchase.completedProduction")}
              </Select.Option>
            </Select>
          )}
          {pageId === PageId.PUR_ORDER_PAYED && (
            <Select
              value={inState}
              onChange={value =>
                updateDraftFilters({ inState: value ?? undefined })
              }
              allowClear
              placeholder={t("purchase.inState")}
              style={{ width: 120 }}
            >
              <Select.Option value={PurchasefInStateEnum.UN_ARRIVED}>
                {t("purchase.unArrived")}
              </Select.Option>
              <Select.Option value={PurchasefInStateEnum.PARTIAL_IN}>
                {t("purchase.partialIn")}
              </Select.Option>
              <Select.Option value={PurchasefInStateEnum.ALL_IN}>
                {t("purchase.allIn")}
              </Select.Option>
            </Select>
          )}
          {!FILTER_PAGE_IDS.includes(pageId as PageId) && (
            <Select
              value={finishState}
              onChange={value =>
                updateDraftFilters({ finishState: value ?? undefined })
              }
              allowClear
              placeholder={t("purchase.deliveryStatus")}
              style={{ width: 120 }}
            >
              <Select.Option value={PurchasefFnishStateEnum.UN_FINISHED}>
                {t("purchase.pendingProduction")}
              </Select.Option>
              <Select.Option value={PurchasefFnishStateEnum.FINISHING}>
                {t("purchase.inProduction")}
              </Select.Option>
              <Select.Option value={PurchasefFnishStateEnum.FINISHED}>
                {t("purchase.finishedProduction")}
              </Select.Option>
            </Select>
          )}
          <div style={{ width: 160 }}>
            <SupplierSelect
              allowClear
              value={supplierId || undefined}
              placeholder={t("purchase.plSupplier")}
              onChange={value =>
                updateDraftFilters({ supplierId: value ?? "" })
              }
            />
          </div>
          {pageId !== PageId.PUR_MT ? (
            <RangePicker
              value={[startTime, endTime]}
              onChange={value =>
                updateDraftFilters({
                  startTime: value?.[0] ?? null,
                  endTime: value?.[1] ?? null,
                })
              }
            />
          ) : (
            <DatePicker
              placeholder={t("purchase.deliveryDatePlaceholder")}
              value={deliveryDeadline}
              onChange={value =>
                updateDraftFilters({ deliveryDeadline: value })
              }
              format="YYYY-MM-DD"
            />
          )}
          <Tooltip title={t("purchase.searchCode")}>
            <Input
              placeholder={t("purchase.searchCode")}
              style={{ width: 200 }}
              value={keyword}
              onChange={e =>
                updateDraftFilters({ keyword: e.target.value.trim() })
              }
              onPressEnter={submitFilters}
            />
          </Tooltip>
        </>
      )}
    </ListFilterBar>
  );

  const submit = (data: OrderAddV2) => {
    setLoading(true);
    orderAdd(data)
      .then(res => {
        // if (res.items && res.items.length > 0) {
        //   for (let i = 0; i < res.items.length; i++) {
        //     const lotStr = res.number + ((Date.now() + i) + "");
        //     await orderLotUpdate(res.items[i].id, { lot: lotStr });
        //   }
        // }
        notification.success({ placement: 'top', message: t("member.changeStatusSucc") });
        preOrder &&
          updateItem({
            ...preOrder,
            inventoryItems: [
              ...(preOrder.inventoryItems || []),
              {
                ...res.items[0],
                order: res
              }
            ]
          });
        setPreOrder(null);
        if (multiInventoryOpen) {
          setMultiInventoryOpen(false);
          setMultiInventoryOpen(false);
          setSelectedRowKeys([]);
          setSelectRows([]);
          fetch(tableRef.current?.offset ?? 0, appliedFilters);
        }
      })
      .catch((err: any) => {
        if (err === 72901) {
          notification.error({
            message: t("order.optErr"),
            description: t('inventory.locNull')
          })
        }
        else notification.error({ placement: 'top', message: t("order.optErr") });
      })
      .finally(() => setLoading(false));
  };

  const handleImport: UploadProps['beforeUpload'] = async (file) => {
    let succNos: string[] = [];
    let errNos: string[] = [];
    let notPurNos: string[] = [];
    let overQuantityNos: Array<{ po: string; maxq: number; count: number }> = [];
    let inventories: OrderV2[] = [];
    try {
      const addListObj = await parseExcelTemplate(file, t);
      setUploading(true);

      let poNumberKeys = Object.keys(addListObj);
      if (poNumberKeys.length === 0) {
        notification.error({ message: t('purchase.noData') })
        return false
      }
      const poAndCount: Record<string, number> = {};
      for (let key in addListObj) {
        let number = addListObj[key].poNumber
        if (poAndCount[number]) {
          poAndCount[number] = poAndCount[number] + addListObj[key].count
        } else poAndCount[number] = addListObj[key].count
      }

      let allPurOrders = await itemFetchs({
        body: {
          orderStates: [PurchaseOrderStateEnum.PAYED],
          supplierId: '',
          keyword: ''
        },
        strs: poNumberKeys.map(key => key.split('*')[0])
      })
      // TODO遍历addListObj，然后根据addListObj的poNumber和allPurOrders里面的number做匹配，如果匹配不上，就把poNumber放到errNos里面，如果匹配的到，就根据count和preTime结合allPurOrders的PurchaseOrderItem数据构造OrderAddV2数据

      // 创建以number为key的Map便于快速查找
      const purOrderMap = new Map<string, PurchaseOrderItem>();
      (allPurOrders.body || []).forEach(item => {
        purOrderMap.set(item.number, item);
      });
      let processed = 0;
      setUploadingProgress(0);
      // 遍历Excel数据进行匹配和分组[检查数据遍历]
      for (const poNumberKey of poNumberKeys) {
        let parsedItem = addListObj[poNumberKey];
        let purchasedOrder = purOrderMap.get(parsedItem.poNumber);

        if (!!!purchasedOrder) {
          notPurNos.push(parsedItem.poNumber);
          continue;
        }
        let totalInventoryCount = purchasedOrder.inventoryItems?.reduce((sum, inv) => sum + (inv.count || 0), 0) || 0;
        let maxQty = purchasedOrder.count + purchasedOrder.spareCount - totalInventoryCount;

        if (poAndCount[parsedItem.poNumber] > maxQty) {
          if (!!!overQuantityNos.find(r => r.po === parsedItem.poNumber)) overQuantityNos.push({ po: parsedItem.poNumber, maxq: maxQty, count: poAndCount[parsedItem.poNumber] });
          continue
        }
      };
      if (notPurNos.length === 0 && overQuantityNos.length === 0) {
        let now = Date.now();
        // 遍历Excel数据进行匹配和分组[生成单据遍历]
        for (const poNumberKey of poNumberKeys) {
          let parsedItem = addListObj[poNumberKey];
          let purchasedOrder = purOrderMap.get(parsedItem.poNumber);
          let lotStr = generateLotV2(purchasedOrder?.product?.code ?? '', purchasedOrder?.order?.supplier?.code ?? '', ++now);
          if (!!!lotStr) {
            notification.error({ message: t('common.lotGetErr'), description: `${t('purchase.printCode')}：${purchasedOrder?.product?.code ?? ''}，${t('purchase.code')}：${purchasedOrder?.order?.supplier?.code ?? ''}` })
            return false
          }
          const orderAddData: OrderAddV2 = {
            type: ChangeEnum.PRE_IN,
            opType: OperateEnum.TRANSACTION,
            desc: '',
            preTime: parsedItem.preTime,
            arrivalAt: null,
            items: [
              {
                sourceType: SourceTypeEnum.PURCHASE_ITEM,
                sourceId: purchasedOrder!.id,
                productId: purchasedOrder!.productId,
                count: parsedItem.count,
                lot: parsedItem.lotStr || lotStr,
                thdlot: '',
                desc: '',
                locations: [],
              }
            ]
          };
          try {
            let inventoryOrder = await orderAdd(orderAddData);
            // if (inventoryOrder.items?.length > 0) {
            //   for (let i = 0; i < inventoryOrder.items.length; i++) {
            //     await orderLotUpdate(inventoryOrder.items[i].id, {
            //       lot: inventoryOrder.number + ((Date.now() + i) + "")
            //     })
            //   }
            // }
            inventories.push(inventoryOrder);
            succNos.push(parsedItem.poNumber)
          } catch (error) {
            errNos.push(parsedItem.poNumber);
          }
          processed += 1;
          setUploadingProgress(Math.round(((processed) / poNumberKeys.length) * 100));
        };
        notification.success({
          message: t('purchase.importDone'),
          description: (
            <>
              {succNos.length > 0 && <div>
                <span style={{ color: "green" }}>{t('purchase.succNum')}：{succNos.length}/{poNumberKeys.length}</span>
                <div>
                  {t('purchase.deliveryNumber')}:
                </div>
                <div>
                  {inventories.map(order => order.number).join(', ')}
                </div>
              </div>}
              {errNos.length > 0 && <div>
                <span style={{ color: "red" }}>{t('purchase.importErrTip')}:</span>
                <div>{errNos.join(', ')}</div>
              </div>}
            </>
          )
        })
      } else {
        notification.error({
          message: t('purchase.importErr'),
          description: (
            <>
              {overQuantityNos.length > 0 && <div>
                <span style={{ color: "orange" }}>{t('purchase.maxQuantityErr')}</span>
                {
                  overQuantityNos.map(over => (
                    <div>
                      {t('purchase.purNo')}:{over.po};
                      {t('purchase.maxDeliveryQty')}:{over.maxq};
                      {t('purchase.excelCount')}:{over.count};
                    </div>
                  ))
                }
              </div>}
              {notPurNos.length > 0 && <div>
                <span style={{ color: "red" }}>{t('purchase.notPurNo')}</span>
                <div>{notPurNos.join(', ')}</div>
              </div>}
            </>
          )
        })
      }
      notification.info({
        type: (notPurNos.length > 0 || overQuantityNos.length > 0) ? "warning" : "success",
        message: t('purchase.importDone'),
        description: (
          <>
            {succNos.length > 0 && <div>
              <span style={{ color: "green" }}>{t('purchase.succNum')}：{succNos.length}/{poNumberKeys.length}</span>
              <div>
                {t('purchase.deliveryNumber')}:
              </div>
              <div>
                {inventories.map(order => order.number).join(', ')}
              </div>
            </div>}
            {errNos.length > 0 && <div>
              <span style={{ color: "red" }}>{t('purchase.importErrTip')}:</span>
              <div>{errNos.join(', ')}</div>
            </div>}

          </>
        ),
        duration: (errNos.length > 0 || overQuantityNos.length > 0) ? 0 : 3000
      })
      if (succNos.length > 0) fetch(0, appliedFilters);

    } catch (error) {
      if ((error as any)?.code === 10088) {
        notification.error({
          placement: 'top',
          message: t("purchase.fileParseError"),
          description: (
            (error as any)?.msg?.map((str: string) => (
              <div>{str}</div>
            ))
          )
        });

      } else {
        notification.error({
          message: t('purchase.matchErr')
        })
      }
    } finally {
      setTimeout(() => {
        setUploading(false);
        setUploadingProgress(0);
      }, 300)
    }
    return false; // 阻止自动上传
  };
  const isSameSup = () => {
    let first = selectedRows[0];
    if (!!selectedRows.find(row => row.order.supplierId !== first.order.supplierId || row.order.currency !== first.order.currency || row.order.payMethod !== first.order.payMethod)) {
      notification.error({
        message: t("purchase.selectPurError"),
        description: t('purchase.selectPurErrorTip')
      })
      return false;
    } else return true
  };

  const getExportItems = useCallback(() => {
    let resItems: ItemType[] = [];
    if (pageId &&
      [
        PageId.PUR_ORDER_PENDING_PAY,
        PageId.PUR_ORDER_PAYED,
        PageId.PUR_ORDER_DONE,
        PageId.PUR_RT,
        PageId.PUR_MT,
        PageId.PUR_HELP_ACCEPT,
        PageId.PUR_ZF
      ].includes(pageId)) {
      resItems.push({
        key: 1,
        label: <ExportExcelButton<PurchaseOrderItem>
          list={list.filter(order => order.order.acceptState !== AcceptStateEnum.REJECTED)}
          columns={exportColumns}
          defaultSelectedColumns={defaultSelectedColumns}
          dataMapper={exportDataMapper}
          fileName="purchase_orders.xlsx"
          sheetName={t("purchase.orderManage")}
          type="link"
          style={{ color: "black" }}
        />
      })
    }
    if (pageId && [PageId.PUR_ORDER_PAYED].includes(pageId)) {
      resItems.push({
        key: 2,
        label: <ExportExcelButton<PurchaseOrderItem>
          list={list.filter(order => order.order.acceptState !== AcceptStateEnum.REJECTED)}
          isAll
          loadData={handleExportAll}
          columns={exportColumns}
          defaultSelectedColumns={defaultSelectedColumns}
          dataMapper={exportDataMapper}
          fileName="purchase_orders_all.xlsx"
          sheetName={t("purchase.orderManage")}
          type="link"
          style={{ color: "black" }}
        />
      })
    }
    if (pageId && [PageId.PUR_ORDER_DONE].includes(pageId)) {
      resItems.push({
        key: 3,
        label: <ExportExcelButton<PurchaseOrderItem>
          list={list}
          isAll
          loadData={handleExportAll}
          columns={exportColumns}
          defaultSelectedColumns={defaultSelectedColumns}
          dataMapper={exportDataMapper}
          fileName="purchase_orders_done_all.xlsx"
          sheetName={t("purchase.orderManage")}
          type="link"
          style={{ color: "black" }}
        />
      })
    }
    if (pageId && [PageId.PUR_HELP_ACCEPT].includes(pageId)) {
      resItems.push({
        key: 4,
        label: <ExportExcelButton<PurchaseOrderItem>
          list={list}
          isAll
          loadData={handleExportAll}
          columns={exportColumns}
          defaultSelectedColumns={defaultSelectedColumns}
          dataMapper={exportDataMapper}
          fileName="purchase_orders_help_accept_all.xlsx"
          sheetName={t("purchase.orderManage")}
          type="link"
          style={{ color: "black" }}
        />
      })
    }
    if (pageId && [PageId.PUR_ZF].includes(pageId)) {
      resItems.push({
        key: 5,
        label: <ExportExcelButton<PurchaseOrderItem>
          list={list}
          isAll
          loadData={handleExportAllZF}
          columns={exportColumns}
          defaultSelectedColumns={defaultSelectedColumns}
          dataMapper={exportDataMapper}
          fileName="purchase_orders_zf_all.xlsx"
          sheetName={t("purchase.orderManage")}
          type="link"
          style={{ color: "black" }}
        />
      })
    }
    if (pageId && [PageId.PUR_MT].includes(pageId)) {
      resItems.push({
        key: 6,
        label: <ExportExcelButton<PurchaseOrderItem>
          list={list}
          isAll
          loadData={handleExportAll}
          columns={exportColumns}
          defaultSelectedColumns={defaultSelectedColumns}
          dataMapper={exportDataMapper}
          fileName="material_tracking_all.xlsx"
          sheetName={t("layout.materialTracking")}
          type="text"
          style={{ color: "black" }}
        />
      })
    }
    if (pageId && [PageId.PUR_RT].includes(pageId)) {
      resItems.push({
        key: 7,
        label: <ExportExcelButton<PurchaseOrderItem>
          list={list}
          isAll
          loadData={handleExportAllReturn}
          columns={exportColumns}
          defaultSelectedColumns={defaultSelectedColumns}
          dataMapper={exportDataMapper}
          fileName="purchase_return_all.xlsx"
          sheetName={t("layout.returnAndExchange")}
          type="text"
          style={{ color: "black" }}
        />
      })
    }
    return resItems;
  }, [pageId, t, exportDataMapper, defaultSelectedColumns, exportColumns, handleExportAllReturn, handleExportAllZF, handleExportAll, list])
  const getInventoryItems = useCallback(() => {
    let resItems: ItemType[] = [];
    resItems.push({
      key: 2,
      label: <SConModal title={t('common.tip')} content=""
        contentNode={
          <>
            <div>{t('purchase.inboundTemplateTip1')}</div>
            <div>{t('purchase.inboundTemplateTip2')}</div>
            <div>{t('purchase.inboundTemplateTip3')}</div>
            <div>{t('purchase.inboundTemplateTip4')}</div>
            <div>{t('purchase.inboundTemplateTip5')}</div>
          </>
        }
        onOk={() => Promise.resolve(downloadTemplate(t))} okText={t('purchase.iHaveKnown')} >
        <Button style={{ color: "black" }} type="link">{t('common.matPurTmp')}</Button>
      </SConModal>
    })
    resItems.push({
      key: 3,
      label: <Upload
        accept=".xlsx,.xls"
        beforeUpload={handleImport}
        showUploadList={false}
        disabled={uploading}
      >
        <Button style={{ color: "black" }} type="link" loading={uploading}>{t('common.genPuInv')}</Button>
      </Upload>
    })
    resItems.push({
      key: 4,
      label: <Button style={{ color: "black" }} type="link" onClick={() => setOpenImport(true)} >{t('common.suppInv')}</Button>
    })
    if (pageId && [PageId.PUR_ORDER_PAYED, PageId.PUR_MT].includes(pageId)) {
      resItems.push({
        key: 5,
        label: <Button style={{ color: "black" }} type="link"
          disabled={selectedRows.length === 0}
          onClick={() => {
            let unresolved = selectedRows.filter(row => row.order.acceptState !== AcceptStateEnum.RESOLVED);
            if (!!unresolved.length) return notification.error({ message: t('purchase.notResolved'), description: unresolved.map(u => u.number).join(', ') })
            let same = isSameSup();
            same && setMultiInventoryOpen(true);
          }}
        >
          {t("purchase.batchDeliveryNote")}
        </Button>
      })
    }
    return resItems;
  }, [pageId, t, downloadTemplate, handleImport, uploading, selectedRows, setOpenImport, setMultiInventoryOpen])

  const getPdfItems = useCallback(() => {
    let resItems: ItemType[] = [];
    if (pageId && [PageId.PUR_ORDER_PAYED].includes(pageId) && printState === PrintStateEnum.PRINTED) {
      resItems.push({
        key: 2,
        label: <Button type="link" style={{ color: "black" }} onClick={handleMultiDown}>{t("purchase.multyDown")}</Button>
      })
    }
    if (pageId && [PageId.PUR_ORDER_PAYED].includes(pageId)) {
      resItems.push(
        {
          key: 3,
          label: <BatchPurchaseQCPrint type="link" style={{ color: selectInventories.length === 0 ? "#b8b8b8" : "black" }}
            selectedRows={selectedRows as Array<PurchaseOrderItem>}
            disabled={selectInventories.length === 0}
            onStart={() => setPrintLoading(true)}
            onEnd={() => setPrintLoading(false)}
            clickValid={isSameSup}
          />
        }, {
        key: 4,
        label: <PrintInventoryV2
          showBottom type="link" style={{ color: selectInventories.length === 0 ? "#b8b8b8" : "black" }}
          printType={PrintType.NORMAL}
          selectedRows={selectInventories}
          disabled={selectInventories.length === 0}
          onStart={() => setPrintLoading(true)}
          onEnd={() => setPrintLoading(false)}
          btnText={t("purchase.printDeliveryNote")}
          clickValid={isSameSup}
        />
      }
      )
    }
    return resItems
  }, [pageId, t, printState, setPrintLoading, handleMultiDown, isSameSup]);

  const handleSwap = () => {
    if (selectedRows.length === 0) return notification.error({ message: t('purchase.purOrderPl') })
    if (!isSameSup()) return notification.error({ message: t('purchase.selectPurErrorTip') });
    let supplier = selectedRows[0].order.supplier;
    if (!!!supplier.wmsApi) return notification.error({ message: t('purchase.notApi') });
    let rejected = selectedRows.find(row => row.order.acceptState === AcceptStateEnum.REJECTED)
    if (!!rejected) return notification.error({ message: t('purchase.noRejected'), description: rejected.number })

    setOpenSwap(true);
  };

  const handleSwapDone = (order: SaleOrderItemState) => {
    let newItems = selectedRows.map(row => ({
      ...row,
      order: { ...row.order, acceptState: AcceptStateEnum.RESOLVED },
      otherNumber1: row.otherNumber1 ? `${row.otherNumber1},${order.number}` : order.number
    }));
    updateItems(newItems);
    setSelectRows([]);
    setSelectedRowKeys([]);
    setOpenSwap(false);
  }

  // 未下单页勾选只更新 id，其它页继续保留完整行对象给打印/送货等流程。
  const rowSelection: TableProps<AnyObject>["rowSelection"] = useMemo(() => {
    return {
      type: "checkbox",
      // hideSelectAll: pageId === PageId.PUR_ORDER_PENDING_PAY ? false : PageId.PUR_ORDER_PAYED && printState === PrintStateEnum.PRINTED ? false : true,
      selectedRowKeys,
      preserveSelectedRowKeys: isPendingPayPage(pageId) ? true : undefined,
      onChange: (selectedRowKeys_opt, selectedRows_opt, { type }) => {
        if (isPendingPayPage(pageId)) {
          // 跨页选中只把完整行对象写进 ref 缓存，不放进 state 触发表格重渲染。
          selectedRows_opt.forEach(row => {
            if (row?.id) {
              selectedPendingPayRowsRef.current.set(String(row.id), row as PurchaseOrderItem);
            }
          });
          const selectedIdSet = new Set(selectedRowKeys_opt.map(String));
          Array.from(selectedPendingPayRowsRef.current.keys()).forEach(id => {
            if (!selectedIdSet.has(id)) {
              selectedPendingPayRowsRef.current.delete(id);
            }
          });
          setSelectRows([]);
          setSelectedRowKeys(selectedRowKeys_opt);
          return;
        }
        setSelectedRowKeys(selectedRowKeys_opt);
        setSelectRows(selectedRows_opt as PurchaseOrderItem[]);
      },
    };
  }, [list, pageId, printState, selectedRowKeys, t]);

  return (
    <Flex vertical style={{ width: "100%", height: "100%" }}>
      <STableLayout
        loading={listLoading || printLoading}
        dataSource={list}
        columns={columns as ColumnsType<AnyObject>}
        headerChildren={headerChildren}
        scrollX={1600}
        headerSub={
          <Flex style={{ width: "100%", margin: pageId && [PageId.PUR_ORDER_PENDING_PAY, PageId.PUR_MT, PageId.PUR_RT].includes(pageId) ? '-32px 0 10px' : "unset" }} gap={10} align="center">
            {pageId === PageId.PUR_ORDER_PAYED && (
              <div style={{ width: 200 }}>
                <Tabs
                  type="card"
                  activeKey={String(printState)}
                  style={{ width: "100%" }}
                  onChange={key => setPrintState(key as PrintStateEnum)}
                  items={[
                    {
                      label: t("purchase.unPrt"),
                      key: PrintStateEnum.UN_PRINT,
                      disabled: listLoading
                    },
                    {
                      label: t("purchase.prt"),
                      key: PrintStateEnum.PRINTED,
                      disabled: listLoading
                    }
                  ]}
                />
              </div>
            )}
            <Dropdown menu={{ items: getExportItems() }}>
              <Button onClick={(e) => e.preventDefault()}>
                {t('common.export')}
              </Button>
            </Dropdown>
            {pageId === PageId.PUR_ORDER_PENDING_PAY && (
              <Button
                disabled={selectedRowKeys.length === 0}
                onClick={onOrders}
              >
                {t("order.onOrders")}
              </Button>
            )}
            {pageId === PageId.PUR_ORDER_PAYED && <Dropdown menu={{ items: getInventoryItems() }}>
              <Button onClick={(e) => e.preventDefault()}>
                {t('common.inventories')}
              </Button>
            </Dropdown>}
            {pageId !== PageId.PUR_ORDER_PENDING_PAY && <Dropdown menu={{ items: getPdfItems() }}>
              <Button onClick={(e) => e.preventDefault()}>
                {t('common.printInfo')}
              </Button>
            </Dropdown>}

            {pageId &&
              [PageId.PUR_ORDER_PAYED].includes(pageId) &&
              printState !== PrintStateEnum.PRINTED && (
                <PrintOrderList
                  handleStart={() => setPrintLoading(true)}
                  handleEnd={() => setPrintLoading(false)}
                  selectedRows={selectedRows.filter(s => s.order.acceptState !== AcceptStateEnum.REJECTED)}
                  handleOk={items => {
                    updateItems(
                      items.map(item => ({
                        ...(selectedRows.find(
                          sR => item.id === sR.id
                        ) as PurchaseOrderItem),
                        printItem: {
                          desc: "",
                          id: "",
                          purItemId: "",
                          order: { id: item.printOrderId, fileId: item.fileId }
                        }
                      }))
                    );
                    setSelectedRowKeys([]);
                    setSelectRows([]);
                  }}
                  clickValid={() => {
                    let printed = selectedRows.filter(s => !!s.printItem?.order?.id);
                    if (!!printed.length) {
                      notification.error({ message: t('purchase.printedTipErr'), description: printed.map(p => p.number).join(', ') })
                      return false;
                    } else return true;
                  }}
                />
              )}
            {pageId === PageId.PUR_ORDER_PAYED && (
              <BatchCompleteTable
                columns={batchCompleteColumns as ColumnsType<PurchaseOrderItem>}
                {...batchCompleteTable}
              />)}
            {pageId === PageId.PUR_ORDER_PAYED && <Button type="dashed" onClick={() => handleSwap()} >{t('requirement.swapSale')}</Button>}
          </Flex>
        }
        tableLayoutRef={tableRef}
        total={total}
        handleChange={offset => fetch(offset, appliedFilters)}
        rowKey={"id"}
        rowSelection={rowSelection}
      />
      {addOpen && (
        <PurchaseAddOrEdit
          open={addOpen}
          formType="Add"
          onClose={() => setAddOpen(false)}
          onSuccess={() => {
            fetch(0, appliedFilters);
          }}
        />
      )}
      {detail && (
        <PurchaseDetail
          canEdit={
            hasPermission(currentUser, [UserPermissionEnum.PUR_ORDER_EDIT]) &&
            pageId !== PageId.PUR_ORDER_DONE
          }
          order={detail}
          setRequirementDetail={(data: any) => setRequirementDetail(data)}
          key={detail?.id}
          handleChangeStatus={() => {
            rmItem(detail?.id);
            setDetail(null);
          }}
          handleOk={(data, item, itemId) => {
            const promiseApis: Array<Promise<void>> = [];
            const needEditOrder = !isEqualVal<PurchaseOrderAdd>(
              detail.order as unknown as PurchaseOrderAdd,
              data,
              [
                "amount",
                "rateAmount",
                "supplierId",
                "remark",
                "currency",
                "payMethod",
                "receiver",
                "receiverAddress",
                "receiverContact",
                "receiverMobile"
              ]
            );
            const needEditItem = !isEqualVal<PurchaseOrderAddItem>(
              detail as unknown as PurchaseOrderAddItem,
              item,
              [
                "type",
                "priceId",
                "count",
                "amount",
                "rateAmount",
                "scheduledOrderTime",
                "deliveryDeadline",
                "estimateArrivalAt",
                "remark",
                "deliveredQuantity",
                "taxRate"
              ]
            );
            if (needEditOrder) {
              promiseApis.push(update(detail?.orderId ?? "", data));
            }
            if (needEditItem) {
              promiseApis.push(updateSaleItem(itemId, item));
            }
            return Promise.allSettled(promiseApis)
              .then(res => {
                let description = "";
                let message = t("common.editError");
                const map: {
                  [key in number]: string;
                } = {
                  10010: t("common.networkError"),
                  71802: t("purchase.orderNotExisted")
                };
                if (needEditOrder && needEditItem) {
                  if (
                    res[0].status === "rejected" &&
                    res[1].status === "rejected"
                  ) {
                    description = `${map[res[0].reason]}, ${map[res[1].reason]
                      }`;
                  } else if (
                    res[0].status === "rejected" &&
                    res[1].status === "fulfilled"
                  ) {
                    message = t("sale.orderErrorItemSuccess");
                    description = `${map[res[0].reason]}`;
                    updateItem({ ...detail, ...item });
                  } else if (
                    res[0].status === "fulfilled" &&
                    res[1].status === "rejected"
                  ) {
                    message = t("sale.orderSuccessItemError");
                    description = `${map[res[1].reason]}`;
                    updateItem({
                      ...detail,
                      order: { ...detail.order, ...data, items: [] }
                    });
                  } else {
                    updateItem({
                      ...detail,
                      ...item,
                      order: { ...detail.order, ...data, items: [] }
                    });
                  }
                } else if (needEditOrder || needEditItem) {
                  if (res[0].status === "rejected") {
                    description = map[res[0].reason];
                  } else {
                    updateItem({
                      ...detail,
                      ...item,
                      order: { ...detail.order, ...data, items: [] }
                    });
                  }
                }

                if (description) {
                  notification.error({ placement: 'top', message, description });
                } else {
                  if (needEditOrder || needEditOrder)
                    notification.success({
                      placement: 'top',
                      message: t("product.modifySuccess")
                    });
                  setDetail(null);
                }
              })
              .catch(err => {
                console.error(err);
              });
          }}
          open={!!detail}
          confirmLoading={updateLoading || updateItemLoading}
          handleCancel={() => setDetail(null)}
          // leftTitle={t("common.edit")}
          orderItemId={detail.id}
        />
      )}

      {inOrder && (
        <ChangeForm
          title={t("warehouse.inQuantity")}
          numberTip={t("warehouse.inQuantity")}
          numberPlTip={t("warehouse.plInQuantity")}
          formTitle={t("warehouse.inQuantity")}
          order={{
            sourceId: inOrder.id,
            productId: inOrder.productId,
            changeType: ChangeEnum.IN,
            sourceType: SourceTypeEnum.PURCHASE_ITEM
          }}
          setOrder={() => setInOrder(null)}
        />
      )}
      <Modal
        title={t("purchase.rejectDetail")}
        open={!!showDetail}
        onCancel={() => setShowDetail(null)}
        footer={null}
      >
        <div>
          <div>
            <p>
              {t("purchase.state")}:{" "}
              {showDetail?.order?.acceptState === AcceptStateEnum.REJECTED
                ? t("purchase.reject")
                : ""}
            </p>
            <p>
              {t("purchase.rejectDate")}:{" "}
              {dateFormat(dayjs(showDetail?.order?.acceptedAt))}
            </p>
            <p>
              {t("purchase.operationPerson")}:{" "}
              {showDetail?.order?.acceptor.name1 ||
                showDetail?.order?.acceptor.name2 ||
                showDetail?.order?.acceptor.mobile}
            </p>
            <div>
              <Button
                type={"primary"}
                onClick={() => {
                  if (
                    showDetail?.product &&
                    showDetail?.quotationRequest?.requirementItem
                  ) {
                    setRequirementDetail({
                      ...showDetail.quotationRequest.requirementItem,
                      product: showDetail.product
                    });
                    setShowDetail(null);
                  } else
                    notification.error({
                      placement: 'top',
                      message: t("purchase.noReq"),
                      description: t("purchase.noReqDesc")
                    });
                }}
              >
                {t("purchase.reOrder")}
              </Button>
            </div>
          </div>
        </div>
      </Modal>
      {requirementDetail && (
        <QuoteProgressDetail
          detail={requirementDetail}
          mrd={requirementDetail.requirement?.mrd || null}
          onCancel={() => setRequirementDetail(null)}
        />
      )}

      {preOrder && (
        <InventoryForm
          open={true}
          changeType={ChangeEnum.PRE_IN}
          formTitle={t("purchase.delivery")}
          handleCancel={() => setPreOrder(null)}
          fetchApi={(...args) =>
            fetchProductApi(...(args as unknown as [string, CommonListParams]))
          }
          handleOk={orderAddData => {
            submit(orderAddData);
            // return orderAdd(item)
          }}
          // handleSaveDraft={(items) => handleAddDraft(items)}
          confirmLoading={reloading}
          value={preOrder?.product}
          id={preOrder?.orderId}
          sourceId={preOrder?.id}
          loading={loading}
          purchaseOrder={preOrder.order}
          purchaseOrderItem={preOrder}
          detail={preOrder}
        />
      )}
      {multiInventoryOpen && (
        <MultiInventory
          open={multiInventoryOpen}
          selectedRows={selectedRows}
          onCancel={() => setMultiInventoryOpen(false)}
          onOk={data => {
            // 调用submit方法处理批量送货单
            submit(data);
          }}
          loading={loading}
        />
      )}
      <ExportProgressModal visible={exportLoading} progress={exportProgress} />
      <ExportProgressModal visible={uploading} progress={uploadingProgress} title={t('purchase.importInbound') + '...'} processLabel={t('purchase.importInbound')} />
      {
        exportLoading && <Modal title={t('common.exportAllExcel') + "..."} closable={false} footer={null} maskClosable={false} open={exportLoading} centered width={1000} >
          <Flex style={{ marginTop: 120, marginBottom: 100 }} justify="center" >
            <Spin spinning={exportLoading} size="large" />
          </Flex>
          <Progress percent={exportProgress} />
          <span>{`${t('common.exporting')}：${exportProgress}%`}</span>
        </Modal>
      }
      {requirementData && <RequirementDetail
        id={requirementData.id}
        number={requirementData.number}
        open={!!requirementData}
        onCancel={() => setRequirementData(null)}
        handleCancel={() => setRequirementData(null)}
        handleOk={() => setRequirementData(null)}
      />}
      {
        openImport && <MatchSupplierOrder open={openImport} onClose={() => setOpenImport(false)} onSuccess={() => { }} />
      }
      {
        openSwap && <PurSwapSale open={openSwap} orders={selectedRows} onClose={() => setOpenSwap(false)} onSuccess={handleSwapDone} />
      }
    </Flex>
  );
};

export default PurchaseOrderList;
